import React, { Component } from 'react';
import ethereum from 'decentralized/ethereum.js';
import DocumentationSidebar from './DocumentationSidebar.js';
import DocumentationViewer from './DocumentationViewer.js';
import '../../Documentation.scss';

class Documentation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            documentationToShow: 'Getting Started',
        };

        window.documentation = true;

        ethereum.store = this.props.store;
        ethereum.crypto.store = this.props.store;
    }
    render() {
        return (
            <div className="documentation">
              <DocumentationSidebar
                onClick={(name) => this.setState({documentationToShow: name})}
                toShow={this.state.documentationToShow} />
                <DocumentationViewer
                  store={this.props.store}
                  goToLink={(name) => {
                      this.setState({documentationToShow: name});
                      window.scrollTo(0,0);
                  }}
                  toShow={this.state.documentationToShow}/>
            </div>
        );
    }
}

export default Documentation;
